module.exports = __webpack_public_path__ + "img/home_type_express.3220ae7b.webp";